import { ApiService, handlerError } from "../ApiService";
import {
  saveShiftsData,
  responseSaveShifts
} from "./transform/ShiftsTransform";

const ShiftsService = {};

/**
 * Guarda las guardias en el backend
 * @param {Object} data - Datos de las guardias a guardar
 * @param {Array} data.shifts - Array de trabajadores con sus guardias
 * @param {string} data.id_patient - ID del paciente (opcional)
 * @param {string} data.id_dashboard - ID del dashboard
 * @param {Object} data.filter - Filtros adicionales (opcional)
 * @returns {Promise} Promesa con la respuesta del backend
 */
ShiftsService.saveShifts = (data) => {
  return ApiService.post('', saveShiftsData(data))
    .then(responseSaveShifts)
    .catch(handlerError);
};

export default ShiftsService;
